<template>
  <div class="app-container">
    <el-card class="box-card" style="margin-bottom: 10px">
      <el-form :inline="false" label-position="top" size="small">
        <el-row :gutter="20">
          <el-col :span="7">
            <!--创建时间-->
            <el-form-item prop="dateType">
              <template slot="label">
                <div class="selectLabel">
                  <el-select v-model="dateType" style="width: 210px">
                    <el-option key="1" :label="$t('newOrder.orderCreateTime')" :value="1" />
                    <el-option key="3" :label="$t('GlobalSetObj.TimePickUpFromFirstLevelSortingCenter')" :value="3" />
                    <el-option key="2" :label="$t('trajectory.Signingtime')" :value="2" />
                  </el-select>
                </div>
              </template>
              <el-date-picker
                v-model="timeValue"
                :clearable="false"
                :default-time="['00:00:00', '23:59:59']"
                :format="$i18n.locale === 'zh' ? zhDate : ptDate"
                :picker-options="pickerOptions"
                :placeholder="$t('newOrder.SelectDatetime')"
                range-separator="~"
                style="width: 100%"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                @blur="refreshDate"
              />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <!--大区-->
            <el-form-item :label="$t('collectionCenter.region')" prop="region">
              <el-select
                v-model="region"
                :placeholder="$t('placeOrder.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
                @change="selectRegionChange"
              >
                <el-option
                  v-for="item in regionOptions"
                  :key="item.id"
                  :label="$i18n.locale === 'zh' ? item.zhName : item.puName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <!--州-->
            <el-form-item :label="$t('GlobalSetObj.Estado')" prop="preDeliverState">
              <el-select
                v-model="preDeliverState"
                :placeholder="$t('placeOrder.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in receiveStateList"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-button
              icon="el-icon-search" size="small" type="primary"
              @click="searchTable(1)"
            >
              {{ $t('GlobalSetObj.search') }}
            </el-button>
            <el-button icon="el-icon-refresh-left" size="small" @click="searchTable(2)">
              {{ $t('operationCenter.reset') }}
            </el-button>
            <el-button
              size="small" style="margin-bottom: 10px" @click="allExportOrder"
            >{{ $t('newOrder.export') }}
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="box-card">
      <el-table
        :cell-class-name="cellClassName"
        :data="tableData"
        :header-cell-style="{ background: '#f2f2f2', color: 'black', textAlign: 'center' }"
        :span-method="arraySpanMethod"
        border
      >
        <el-table-column
          v-for="(item, ind) in columnList"
          :key="ind"
          :align="item.align"
          :label="item.label"
          :min-width="item.width"
          :prop="item.prop"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <!-- 业务模板 - 快递 -->
            <div v-if="item.prop === 'businessModule'">
              {{ $t('collectionCenter.expressDelivery') }}
            </div>
            <!-- 业务类型 -->
            <div v-else-if="item.prop === 'businessType'">
              <!-- 本地 -->
              <div v-if="scope.row[item.prop] === 'local'">{{ $t('collectionCenter.local') }}</div>
              <!-- 跨境 -->
              <div v-else-if="scope.row[item.prop] === 'crossBorder'">
                {{ $t('collectionCenter.crossBorder') }}
              </div>
              <!-- 其他 -->
              <div v-else-if="scope.row[item.prop] === 'crossBorderAll'">
                {{ $t('collectionCenter.other') }}
              </div>
            </div>
            <div v-else>
              {{
                scope.row[item.prop] !== '' &&
                  scope.row[item.prop] !== null &&
                  scope.row[item.prop] !== undefined
                  ? scope.row[item.prop]
                  : '--'
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, ind) in currentColumnList"
          :key="ind + item.prop"
          :align="item.align"
          :label="item.label"
          :min-width="item.width"
          :prop="item.prop"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div>
              {{
                scope.row[item.prop] !== '' &&
                  scope.row[item.prop] !== null &&
                  scope.row[item.prop] !== undefined
                  ? scope.row[item.prop]
                  : '--'
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('tablePrice.dayOverDay1')"
          align="center"
          prop="compareBeforeYesterday"
          width="160"
        >
          <template slot-scope="scope">
            <div :style="{ color: scope.row.compareBeforeYesterdayStyle ? '#009c37' : 'red' }">
              {{ scope.row.compareBeforeYesterday || '--' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('tablePrice.weekOverWeek1')"
          align="center"
          prop="compareLastWeek"
          width="160"
        >
          <template slot-scope="scope">
            <div :style="{ color: scope.row.compareLastWeekStyle ? '#009c37' : 'red' }">
              {{ scope.row.compareLastWeek || '--' }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { getDataOrderDailyApi, getRegionOptions, selectState } from '@/api/orderApi';
import { orderDailyExport } from '@/api/newExpressAPI';
import { goResourceTaskList } from '@/utils/goExportList';

export default {
  name: 'SingleVolumeDailyReport',
  data() {
    return {
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      choiceDate0: '',
      timeValue: [],
      dateType: 1,
      pickerOptions: {
        // 设置不能选择的日期
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate0 = minDate.getTime();
          if (maxDate) {
            this.choiceDate0 = '';
          }
        },
        disabledDate: (time) => {
          const choiceDateTime = new Date(this.choiceDate0).getTime();
          const minTime = new Date(choiceDateTime).setDate(new Date(choiceDateTime).getDate() - 30);
          const maxTime = new Date(choiceDateTime).setDate(new Date(choiceDateTime).getDate() + 30);
          const min = minTime;
          // const newDate = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000;
          const newDate = ((d) => (d.setHours(0, 0, 0, 0), d.setDate(d.getDate() + 1), d.getTime()))(new Date());
          const max = newDate < maxTime ? newDate : maxTime;
          // 如果已经选中一个日期 则 返回 该日期前后一个月时间可选
          if (this.choiceDate0) {
            return time.getTime() < min || time.getTime() > max;
          }
          // 若一个日期也没选中 则 返回 当前日期以前日期可选
          return time.getTime() > newDate;
        }
      },
      columnList: [
        // 业务模块
        {
          label: this.$t('GlobalSetObj.BusinessModule'),
          prop: 'businessModule',
          width: 160,
          align: 'center'
        },
        // 业务类型
        {
          label: this.$t('navbar.businessType'),
          prop: 'businessType',
          width: 150,
          align: 'center'
        },
        // 客户
        {
          label: this.$t('GlobalSetObj.client'),
          prop: 'customerName',
          width: 160,
          align: 'center'
        },
        // 大区
        { label: this.$t('tablePrice.region'), prop: 'region', width: 160, align: 'center' },
        // 收件人州
        {
          label: this.$t('newOrder.RecipientState'),
          prop: 'preDeliverState',
          width: 150,
          align: 'center'
        },
        // 合计
        { label: this.$t('GlobalSetObj.sum'), prop: 'total', width: 120, align: 'center' },
        // 当月累计
        {
          label: this.$t('tablePrice.monthToDate'),
          prop: 'monthTotal',
          width: 150,
          align: 'center'
        }
      ],
      currentColumnList: [],
      tableData: [],
      region: '',
      preDeliverState: '',
      receiveStateList: [],
      regionOptions: []
    };
  },
  created() {
    this.getAddressList();
    this.getTimer();
    this.getTableData();
    this.getAddress();
  },
  methods: {
    // 选择大区变化
    selectRegionChange() {
      this.preDeliverState = '';
      this.receiveStateList = [];
      if (this.region) {
        this.regionOptions.map(item => {
          if (item.id === this.region) {
            this.receiveStateList = item.states;
          }
        });
      } else {
        this.getAddress();
      }
    },
    // 获取大区选项
    getAddressList() {
      getRegionOptions().then(res => {
        console.log(res, '===res');
        if (res.code === 200) {
          this.regionOptions = res.data;
        }
      });
    },
    getAddress(name = '') {
      // level 0 州    1 城市   2 地区
      const params = {
        pageNumber: 1,
        pageSize: 200,
        params: {
          name,
          countryName: 'Brazil'
        }
      };
      selectState(params, false).then((res) => {
        if (res.code === 200) {
          this.receiveStateList = res.data.records.map(item => {
            return item.shortName;
          });
        }
      });
    },
    // 获取最近一星期时间
    getTimer() {
      const day = new Date();
      const brazilTime = day.toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' });
      const today = dayjs(brazilTime).format('YYYY-MM-DD');
      const oneWeekAgo = dayjs(brazilTime).subtract(6, 'day').format('YYYY-MM-DD');
      this.timeValue = [oneWeekAgo + ' 00:00:00', today + ' 23:59:59'];
    },
    // 日期选择器失去焦点
    refreshDate() {
      this.choiceDate0 = '';
    },
    // 搜索、重置
    searchTable(type) {
      if (type === 2) {
        // 重置
        this.dateType = 1;
        this.region = null;
        this.preDeliverState = null;
        this.receiveStateList = [];
        this.getAddress();
        this.getTimer();
      }
      this.getTableData();
    },
    // 将日期转换为 YYYY-MM-DD 格式
    convertDateFormat(dateString) {
      const dateArr = dateString.split(/[-/]/);
      const day = Number(dateArr[2]);
      const month = Number(dateArr[1]);
      const year = Number(dateArr[0]);
      // 获取 YYYY-MM-DD 格式
      return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    },
    // 获取表格数据
    getTableData() {
      if (this.timeValue && this.timeValue.length === 2) {
        const queryParams = {
          dateType: this.dateType,
          startTime: this.timeValue[0],
          endTime: this.timeValue[1],
          region: this.region || null,
          preDeliverState: this.preDeliverState || null
        };
        getDataOrderDailyApi(queryParams).then((res) => {
          if (res.code === 200) {
            if (!res.data) {
              this.tableData = [];
              this.currentColumnList = [];
              return;
            }
            const daysOfWeek = {
              Sun: this.$t('GlobalSetObj.Sunday'), // '星期日',
              Mon: this.$t('GlobalSetObj.Monday'), // '星期一',
              Tue: this.$t('GlobalSetObj.Tuesday'), // '星期二',
              Wed: this.$t('GlobalSetObj.Wednesday'), // '星期三',
              Thu: this.$t('GlobalSetObj.Thursday'), // '星期四',
              Fri: this.$t('GlobalSetObj.Friday'), // '星期五',
              Sat: this.$t('GlobalSetObj.Saturday') // '星期六'
            };
            this.currentColumnList = res.data.dateList.map((item) => {
              const dateWeek = item.split(/[(（]/)[0];
              // 删除 '）'
              const removeLastCharacter = (str) => {
                return str.slice(0, -1);
              };
              const week = daysOfWeek[removeLastCharacter(item.split(/[(（]/)[1])]; // 星期语言转换
              const date = this.convertDateFormat(dateWeek);
              const currentDate = new Date(date);
              const month = String(currentDate.getMonth() + 1).padStart(2, '0');
              const day = String(currentDate.getDate()).padStart(2, '0');
              const formattedDate =
                this.$i18n.locale === 'zh'
                  ? month + this.$t('newOrder.Month') + day + this.$t('newOrder.day')
                  : day + this.$t('newOrder.day') + month + this.$t('newOrder.Month');
              return {
                label: formattedDate + '(' + week + ')',
                prop: item,
                width: 150,
                align: 'center'
              };
            });
            // 合并customerName相同的数据
            const groupedData = res.data.customerDailyDataList.reduce((acc, item) => {
              if (item.customerName) {
                if (!acc[item.customerName]) {
                  acc[item.customerName] = [];
                }
                acc[item.customerName].push(item);
              }
              return acc;
            }, {});
            // 每个客户的合计行
            const summaryRows = Object.entries(groupedData).map(([customerName, items]) => {
              if (customerName !== this.$t('GlobalSetObj.sum') && customerName !== null) {
                const dailySummary = {};
                let totalSum = 0;
                let monthTotalSum = 0;
                res.data.dateList.forEach(dateKey => {
                  const dailyTotal = items.reduce((sum, item) => sum + (item.dailyData[dateKey] || 0), 0);
                  dailySummary[dateKey] = dailyTotal;
                  totalSum += dailyTotal;
                });
                // 如果每个 item 有 monthTotal，则累加
                if (items[0]?.monthTotal) {
                  monthTotalSum = items.reduce((sum, item) => sum + (item.monthTotal || 0), 0);
                }
                return {
                  businessModule: 'express',
                  businessType: items[0].businessType, // 可根据实际业务类型填充
                  customerName: customerName,
                  originalCustomerName: customerName, // 👈 新增字段：原始客户名
                  region: this.$t('GlobalSetObj.sum'), // 合计,
                  preDeliverState: '',
                  ...dailySummary,
                  total: totalSum,
                  monthTotal: monthTotalSum,
                  compareBeforeYesterday: items[0].compareBeforeYesterday,
                  compareLastWeek: items[0].compareLastWeek
                };
              }
            });
            const dataArr = [];
            Object.entries(groupedData).forEach(([customerName, items]) => {
              // 插入对应的合计行
              const summaryRow = summaryRows.find(row =>
                row.region === this.$t('GlobalSetObj.sum') &&
                row.originalCustomerName === customerName
                // && row.businessType !== 'crossBorderAll' // 其他不需要合计
              );
              if (summaryRow) {
                dataArr.push(summaryRow);
              }

              // 插入客户数据行
              dataArr.push(
                ...items.map(item => ({
                  ...item,
                  ...item.dailyData
                }))
              );
            });
            dataArr.forEach(item => {
              switch (item.customerName) {
                case 'shein':
                  item.customerName = this.$i18n.locale === 'zh' ? 'SHEIN本地' : 'SEHIN Local';
                  break;
                case 'brazilLocalCustomer':
                  item.customerName =
                    this.$i18n.locale === 'zh'
                      ? '巴西本地客户'
                      : this.$t('collectionCenter.BrazilianLocalCustomer');
                  break;
                case 'insider':
                  item.customerName =
                    this.$i18n.locale === 'zh' ? 'insider(MG客户)' : 'insidertomador';
                  break;
                case 'sheinCrossBorder':
                  item.customerName =
                    this.$i18n.locale === 'zh' ? 'SEHIN跨境' : 'SEHIN Transfronteiriça';
                  break;
                case 'cainiaoCrossBorder':
                  item.customerName =
                    this.$i18n.locale === 'zh' ? '菜鸟跨境' : 'cainiao Transfronteiriça';
                  break;
                case 'shopeeCrossBorder':
                  item.customerName =
                    this.$i18n.locale === 'zh' ? 'shopee跨境' : 'shopee Transfronteiriça';
                  break;
                case 'temuCrossBorder':
                  item.customerName =
                    this.$i18n.locale === 'zh' ? 'temu跨境' : 'temu Transfronteiriça';
                  break;
              }
            });
            // 将本地数据排在前面，跨境排在后面
            dataArr.sort((a, b) => {
              if (a.businessType === 'local' && b.businessType !== 'local') {
                return -1; // a 在 b 前面
              }
              if (a.businessType !== 'local' && b.businessType === 'local') {
                return 1; // b 在 a 前面
              }
              // 如果 businessType 相同或都不是 'local'，按字母顺序排序
              return a.businessType.localeCompare(b.businessType);
            });
            const objDate = {};
            res.data.dateList.map((item) => {
              objDate[item] = res.data.total[item] || 0;
            });
            const obj = {
              businessModule: 'express', // 快递
              businessType: '',
              customerName: '',
              region: this.$t('GlobalSetObj.Total'), // 总计
              preDeliverState: '',
              total: res.data.customerDailyDataList[0].total,
              monthTotal: res.data.customerDailyDataList[0].monthTotal,
              compareBeforeYesterday: res.data.customerDailyDataList[0].compareBeforeYesterday,
              compareLastWeek: res.data.customerDailyDataList[0].compareLastWeek,
              ...objDate
            };
            dataArr.unshift(obj);
            this.tableData = dataArr;
            this.tableData.pop();
            this.tableData.forEach((item) => {
              item.compareBeforeYesterdayStyle = this.isPercentageGreaterThanZero(
                item.compareBeforeYesterday
              );
              item.compareLastWeekStyle = this.isPercentageGreaterThanZero(item.compareLastWeek);
            });
          }
        });
      } else {
        this.$message({
          type: 'warning',
          message: this.$t('collectionCenter.PleaseSelectTime')
        });
      }
    },
    // 合并单元格表格业务模块相同的数据
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      // 业务模块
      if (columnIndex === 0) {
        if (rowIndex > 0 && row.businessModule === this.tableData[rowIndex - 1].businessModule) {
          return [0, 0];
        } else {
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.tableData.length; i++) {
            if (this.tableData[i].businessModule === row.businessModule) {
              rowspan++;
            } else {
              break;
            }
          }
          return [rowspan, 1];
        }
      }
      // 业务类型
      if (columnIndex === 1) {
        if (rowIndex > 0 && row.businessType === this.tableData[rowIndex - 1].businessType) {
          return [0, 0];
        } else {
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.tableData.length; i++) {
            if (this.tableData[i].businessType === row.businessType) {
              rowspan++;
            } else {
              break;
            }
          }
          return [rowspan, 1];
        }
      }
      // 客户合并
      if (columnIndex === 2) {
        if (rowIndex > 0 && row.customerName === this.tableData[rowIndex - 1].customerName) {
          return [0, 0];
        } else {
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.tableData.length; i++) {
            if (this.tableData[i].customerName === row.customerName) {
              rowspan++;
            } else {
              break;
            }
          }
          return [rowspan, 1];
        }
      }
      // 大区合并
      if (columnIndex === 3) {
        if (rowIndex > 0 && row.region === this.tableData[rowIndex - 1].region) {
          return [0, 0];
        } else {
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.tableData.length; i++) {
            if (this.tableData[i].region === row.region) {
              rowspan++;
            } else {
              break;
            }
          }
          return [rowspan, 1];
        }
      }
      return [1, 1];
    },
    // 导出
    allExportOrder() {
      if (this.timeValue && this.timeValue.length === 2) {
        const queryParams = {
          dateType: this.dateType,
          startTime: this.timeValue[0],
          endTime: this.timeValue[1],
          region: this.region || null,
          preDeliverState: this.preDeliverState || null
        };
        orderDailyExport(queryParams).then((res) => {
          if (res.code === 200) {
            goResourceTaskList();
          }
        });
      } else {
        this.$message({
          type: 'warning',
          message: this.$t('collectionCenter.PleaseSelectTime')
        });
      }
    },
    // 设置单元格样式
    cellClassName({ row, column, rowIndex, columnIndex }) {
      // 根据条件返回不同的类名
      if (column.property === 'customerName' && row.customerName === this.$t('GlobalSetObj.sum')) {
        return 'totalStyle';
      }
      // 其他条件...
      return '';
    },
    // 判断百分比是否大于零
    isPercentageGreaterThanZero(percentageStr) {
      const numberStr = percentageStr.replace('%', '');
      const number = parseFloat(numberStr) / 100;
      return number > 0;
    }
  }
};
</script>

<style>
.selectLabel .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  border: none;
  font-weight: bold;
  text-align: left;
  padding: 0;
}

.selectLabel .el-input__icon {
  line-height: 28px !important;
}
</style>
